import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Profil Personnel', icon: 'User' },
    { number: 2, label: 'Parcours Académique', icon: 'GraduationCap' },
    { number: 3, label: 'Centres d\'Intérêt', icon: 'Heart' }
  ];

  const progressPercentage = ((currentStep - 1) / (totalSteps - 1)) * 100;

  return (
    <div className="w-full mb-8 md:mb-10 lg:mb-12">
      <div className="relative">
        <div className="absolute top-6 left-0 right-0 h-1 bg-gray-200 rounded-full">
          <div 
            className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>

        <div className="relative flex justify-between">
          {steps?.map((step) => (
            <div key={step?.number} className="flex flex-col items-center">
              <div 
                className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center transition-all duration-300 ${
                  step?.number < currentStep 
                    ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white' 
                    : step?.number === currentStep
                    ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white ring-4 ring-blue-100' :'bg-white border-2 border-gray-200 text-gray-400'
                }`}
              >
                {step?.number < currentStep ? (
                  <Icon name="Check" size={20} className="md:w-6 md:h-6 lg:w-7 lg:h-7" />
                ) : (
                  <Icon name={step?.icon} size={20} className="md:w-6 md:h-6 lg:w-7 lg:h-7" />
                )}
              </div>
              <span className={`mt-2 md:mt-3 text-xs md:text-sm lg:text-base font-medium text-center max-w-[80px] md:max-w-[100px] lg:max-w-[120px] ${
                step?.number <= currentStep ? 'text-blue-600' : 'text-gray-400'
              }`}>
                {step?.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegistrationProgress;